/**
 * Convert #RRGGBB (or #RGB) → "H S% L%" string compatible with the
 * `hsl(var(--primary))` Tailwind convention used across the app.
 */
export function hexToHslString(hex) {
  if (!hex || typeof hex !== "string") return null;
  let h = hex.trim().replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (!/^[0-9a-f]{6}$/i.test(h)) return null;
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let hh = 0, s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: hh = (g - b) / d + (g < b ? 6 : 0); break;
      case g: hh = (b - r) / d + 2; break;
      case b: hh = (r - g) / d + 4; break;
      default: break;
    }
    hh *= 60;
  }
  return `${Math.round(hh)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

/**
 * Apply brand colors (primary + accent) to CSS variables both in light
 * and dark themes. Called from App.js on mount and on 'ss-settings-updated'.
 */
export function applyBrandTheme(primary, accent) {
  const p = hexToHslString(primary);
  const a = hexToHslString(accent);
  const root = document.documentElement;
  if (p) root.style.setProperty("--primary", p);
  if (a) {
    root.style.setProperty("--accent", a);
    root.style.setProperty("--ring", a);
  }
}
